import { render, staticRenderFns } from "./UserPreferenceEditor.vue?vue&type=template&id=700be3ba&scoped=true"
import script from "./UserPreferenceEditor.vue?vue&type=script&lang=js"
export * from "./UserPreferenceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700be3ba",
  null
  
)

export default component.exports